import { useQuery } from '@tanstack/vue-query';

import { api } from '@/shared/api';
import { sentryModel, useUserStore } from '@/shared/model';
import { bloomreachLib } from '@/shared/lib';

export const useAccount = () => {
  const userStore = useUserStore();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['account'],
    queryFn: () =>
      userStore
        .getUserId()
        .then(userId => api.accounts.fetchAccount(userId))
        .then(({ data }) => {
          bloomreachLib.identify(
            { userId: data.id, email: data.email },
            { birthDate: data.dob },
          );

          return {
            passengers: data.passengers,
            contacts: {
              email: data.email,
              phone: data.phone,
            },
          };
        })
        .catch(error => {
          sentryModel.captureException(
            sentryModel.getReadableError(
              sentryModel.createCustomErrorText(
                sentryModel.errorPrefix.DEFAULT,
                'FETCH_ACCOUNT',
              ),
              error,
            ),
          );
          throw error;
        }),
    /** Since account data never changes after creation there is no need to try to update it */
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isLoading,
    isError,
  };
};
